import { Aggregator } from './aggregator';

/**
 * Aggregator that returns the most frequent string value.
 * If there is a tie, it returns an array of all values with the same maximum frequency.
 */
export class Mode<T extends string> extends Aggregator<T> {
  private counts: Record<T, number> = {} as Record<T, number>;

  constructor() {
    super();
  }

  getAggregated(): T | undefined {
    const entries = Object.entries(this.counts) as [T, number][];
    if (entries.length === 0) {
      return undefined;
    }

    let maxCount = 0;
    let modes: T[] = [];

    for (const [value, count] of entries) {
      if (count > maxCount) {
        maxCount = count;
        modes = [value];
      } else if (count === maxCount) {
        modes.push(value);
      }
    }

    return modes[0];
  }

  reset(): void {
    this.counts = {} as Record<T, number>;
  }

  protected _add(value: T): void {
    this.counts[value] = (this.counts[value] || 0) + 1;
  }
}
